import {
  HashRouter as Router,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";

import Commodities from "../containers/Items";
import UserMaster from "../containers/UserMaster";
import Dashboard from "../containers/Dashboard";
import Login from "../containers/Login";
import RoleMaster from "../containers/RoleMaster";
import RoleVsCapabilityTwo from "../containers/RoleVsCapabilityTwo";
import SystemSettings from "../containers/SystemSettings";
import TariffMaster1 from "../containers/Tariffmaster1";
import ReasonForLost from "../containers/ReasonForlost";
import { useEffect, useRef, useState } from "react";
import { authenticationAPI, BindAPI, IUDAPI, LoginAPI } from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";
import Enquiry from "../containers/Enquiry";
import Holidaymaster from "../containers/Holidaymaster";
// import VillaMaster from "../containers/VillaMaster";
import StaffMaster from "../containers/StaffMaster";
import Rooms from "../containers/Rooms";
import AmenitiesMaster from "../containers/AmenitiesMaster";
import Cancellation from "../containers/Cancellation";
import 'react-calendar/dist/Calendar.css';
import Booking from "../containers/Booking";
import ShiftMaster from "../containers/ShiftMaster";
import IncomeExpenseReport from "../containers/IncomeExpenseReport";
import Payment from "../containers/Payment";
import Receipt from "../containers/Receipt";
import LaundryCompany from "../containers/LaundryCompany";
import CancellationReason from "../containers/CancellationReason";
import Booked from "../containers/Booked";
import Maintenance from "../containers/Maintenance";
// import IncomeExpenseReport from "../containers/IncomeExpenseReport";
import Connector from "../Website/WebsiteConnector";
import CancelledBooking from "../containers/CancelledBooking";




import Enquirytobookingpercentage from "../containers/Enquirytobookingpercentage";
import SalaryPaid from "../containers/SalaryPaid";
// import SalaryMaster from "../containers/Grade";
import Grade from "../containers/Grade";
import EnquiryConversionReport from "../containers/EnquiryConversionReport";
import ComplaintsAndIssues from "../Reports/ComplaintsAndIssues";
import RevenueExpense from "../Reports/RevenueExpense";
import Laundry from "../containers/Laundry";
import OpeningStock from "../containers/Openingstock";
import SalaryMapping from "../containers/SalaryMapping";
import Items from "../containers/Items";
import SupplierMaster from "../containers/SupplierMaster";
import RoomTypeMaster from "../containers/RoomTypeMaster"
import Villadetails from "../Website/Villadetails";
import Feedback from "../containers/Feedback";
import RoomType from "../containers/RoomType";
import ItemsCategory from "../containers/ItemsCategory";
import AmenitiesType from "../containers/AmenitiesType";
import Space from "../containers/Space";
import MappingRoomTypeWithAmenities from "../containers/MappingRoomTypeWithAmenities";
import MappingRoomTypeWithSpaces from "../containers/MappingRoomTypeWithSpaces";
import Client from "../containers/Client";
import PaymentInfoMst from "../containers/PaymentInfoMst";
import Report1 from "../containers/Report1";
import Report2 from "../containers/Report2";
import Consumption from "../containers/Consumption";
import Damages from "../containers/Damages";
import PurchaseItem from "../containers/PurchaseItem";
import State from "../containers/StateMaster";
import City from "../containers/City";

import Countrymaster from "../containers/Countrymaster";
import Amenities from "../containers/Amenities";
import CheckIn from "../containers/CheckIn";
import CheckOut from "../containers/CheckOut";
import RoomBooking from "../containers/RoomBooking";
import EnquiryLost from "../containers/EnquiryLost";
import EnquiryHold from "../containers/EnquriyHold";
import PaymentInfo from "../containers/PaymentInfo";
import Customers from "../containers/Customers";
import MapItemsToCommonSpace from "../containers/MapItemstoCommonSpace";
import Issues from "../containers/Issues";
import Attendance from "../containers/Attendance";
import FoodsAndBeverages from "../containers/FoodsAndBeverages";
// import RoomMaster from "../containers/Rooms";
// import RoomMaster from "../containers/RoomMaster";
import SpaceType from "../containers/Space";
import LaundryIssue from "../containers/LaundryIssue";
import HouseKeeping from "../containers/HouseKeeping";
import LaundryReceipt from "../containers/LaundryReceipt";
import Payroll from "../containers/Payroll";
import Logindemo from "../unusedcode/Logindemo";
import Logindemo3 from "../unusedcode/Logindemo3";
// import ReportEnquiryReports from "../containers/ReportEnquiryReports";
import EnquiryReport from "../Reports/EnquiryReport";
import Complaints from "../containers/Complaints";
import StockLedgerReport from "../Reports/StockLedgerReport";
import StockReport from "../Reports/StockReport";
import BookingReport from "../Reports/BookingReport";
import CheckInReport from "../Reports/CheckInReport";
import CheckOutReport from "../Reports/CheckOutReport";
import Sourcetype from "../containers/Sourcetype";
import ComplaintsList from "../containers/ComplaintsList";
import Position from "../containers/Position";



const RootRouter = () => {
  const { userProfileState, dispatch } = useUserCapability();
  const [tableSdpData, setTableSdpData] = useState([]);
  const [idleTimeInSeconds, setIdleTimeInSeconds] = useState(300);
  const idleTimer = useRef(null);
  const activityInterval = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const systemSettingsData = async () => {
    try {
      const { data } = await BindAPI("SystemSettingsAPI/BindSystemSettings");
      if (data?.Table?.[0]?.SessionTimeInSeconds) {
        setIdleTimeInSeconds(data.Table[0].SessionTimeInSeconds);
      }
    } catch (error) {
      console.error("Failed to fetch system settings", error);
    }
  };

  const logoutUser = async () => {
    clearInterval(activityInterval.current);
    const createdBy = sessionStorage.getItem("createdBy");

    if (createdBy) {
      const data = {
        sessionId: 0,
        mstUserId: Number(createdBy),
        lastActivity: new Date().toISOString(),
        isActive: 0,
        flag: 1,
      };

      try {
        await LoginAPI(data, "Login/Login");
      } catch (error) {
        console.error("Logout API Error", error);
      }
    }

    sessionStorage.clear();
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    const handleTabClose = () => {
      const isReload =
        window.performance?.getEntriesByType("navigation")[0]?.type === "reload";

      if (!isReload) {
        const createdBy = sessionStorage.getItem("createdBy");
        if (createdBy) {
          const data = [{ mstUserId: createdBy, status: 0 }];
          navigator.sendBeacon("UserAPI/IUDLogin", JSON.stringify(data));
        }

        sessionStorage.clear();
        localStorage.clear();
      }
    };

    window.addEventListener("beforeunload", handleTabClose);
    return () => {
      window.removeEventListener("beforeunload", handleTabClose);
    };
  }, []);

  const updateActivity = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
    if (!createdBy) return;

    const data = {
      sessionId: 0,
      mstUserId: Number(createdBy),
      lastActivity: new Date().toISOString(),
      isActive: 1,
      flag: 1,
    };

    try {
      await LoginAPI(data, "Login/Login");
    } catch (error) {
      console.error("Activity Update Error", error);
    }
  };

  useEffect(() => {
    if (location.pathname === '/login') {
      return;
    }
    activityInterval.current = setInterval(updateActivity, 60000);
    return () => clearInterval(activityInterval.current);
  }, [location.pathname]);

  const resetIdleTimer = () => {
    if (idleTimer.current) clearTimeout(idleTimer.current);
    idleTimer.current = setTimeout(logoutUser, idleTimeInSeconds * 1000);
  };

  const refreshUserData = async () => {
    const userName = sessionStorage.getItem("userName");
    const password = sessionStorage.getItem("password");
    const AllSDP = sessionStorage.getItem("AllSDP") || "";
    const AllSDPArray = AllSDP.split(",").map((item) => parseInt(item.trim(), 10));

    if (!userName || !password) {
      console.error("Missing credentials");
      return;
    }

    try {
      const { data } = await authenticationAPI(
        { userName, password },
        "LoginAPI/LoginValid"
      );

      if (data?.jsonString) {
        const tableDatas = JSON.parse(data.jsonString);

        if (["S", "LS"].includes(tableDatas.Table?.[0]?.Result)) {
          const userProfile = tableDatas.Table1 ?? [];
          const userVsCapability = tableDatas.Table2 ?? [];

          if (userProfile.length) {
            const updatedProfile = userProfile.map((item) => ({
              ...item,
              AllSDP: AllSDPArray,
            }));

            sessionStorage.setItem("createdBy", updatedProfile[0]?.MstUserId);
            setTableSdpData(updatedProfile);
            dispatch({ type: "USER_PROFILE", payload: updatedProfile });
          } else {
            console.log("User not found");
          }

          dispatch({ type: "USER_VS_CAPABILITY", payload: userVsCapability });
          localStorage.setItem("jwtToken", data.token);
        }
      }
    } catch (error) {
      console.error("Refresh Login Error", error);
    }
  };

  useEffect(() => {
    if (location.pathname === '/') {
      return;
    }
    const events = [
      "mousemove",
      "keydown",
      "scroll",
      "click",
      "touchstart",
      "touchmove",
    ];
    events.forEach((event) => window.addEventListener(event, resetIdleTimer));

    resetIdleTimer();

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer)
      );
      if (idleTimer.current) clearTimeout(idleTimer.current);
    };
  }, [idleTimeInSeconds, location.pathname]);

  useEffect(() => {
    const initialize = async () => {
      await systemSettingsData();

      const userId = sessionStorage.getItem("createdBy");
      if (userId) {
        await refreshUserData();
      }
    };

    initialize();
  }, []);

  return (
    <Routes>
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/login" element={<Login />} />
      <Route path="/usermaster" element={<UserMaster />} />
      <Route path="/rolemaster" element={<RoleMaster />} />
      <Route path="/rolevscapability" element={<RoleVsCapabilityTwo />} />
      <Route path="/systemsettings" element={<SystemSettings />} />
      <Route path="/tariffmaster" element={<TariffMaster1 />} />
      <Route path="/enquiry" element={<Enquiry />} />
      <Route path="/holidaymaster" element={<Holidaymaster />} />
      {/* <Route path="/villamaster" element={<VillaMaster />} /> */}
      {/* <Route path="/rooms" element={<Rooms />} /> */}
      {/* <Route path="/roommaster" element={<RoomMaster />} /> */}
      <Route path="/rooms" element={<Rooms />} />
      <Route path="/reasonforlost" element={<ReasonForLost />} />
      <Route path="/shiftmaster" element={<ShiftMaster />} />
      <Route path="/cancellation" element={<Cancellation />} />
      <Route path="/reasonforlost" element={<ReasonForLost />} />
      <Route path="/consumables" element={<Commodities />} />
      <Route path="/items" element={<Items />} />
      <Route path="/staffmaster" element={<StaffMaster />} />
      <Route path="/booking" element={<Booking />} />
      <Route path="/payment" element={<Payment />} />
      <Route path="/amenitiestype" element={<AmenitiesType />} />
      <Route path="/enquirytobookingpercentage" element={<Enquirytobookingpercentage />} />
      <Route path="/incomeexpensereport" element={<IncomeExpenseReport />} />
      <Route path="/enquirytobookingpercentage" element={<Enquirytobookingpercentage />} />
      {/* <Route path="/incomeexpensereport" element={<IncomeExpenseReport />} /> */}
      <Route path="/salarypaid" element={<SalaryPaid />} />
      <Route path="/grade" element={<Grade />} />
      <Route path="/reasonforcancel" element={<CancellationReason />} />
      <Route path="/enquiryconversion" element={<EnquiryConversionReport />} />
      <Route path="/complaintsandissues" element={<ComplaintsAndIssues />} />
      <Route path="/revenueexpense" element={<RevenueExpense />} />
      <Route path="/complaintsandissues" element={<ComplaintsAndIssues />} />
      <Route path="/revenueexpense" element={<RevenueExpense />} />
      <Route path="/Receipt" element={<Receipt />} />
      <Route path="/laundry" element={<Laundry />} />
      <Route path="/openingstock" element={<OpeningStock />} />
      <Route path="/mapstaffandgrade" element={<SalaryMapping />} />
      {/* <Route path="/laundrymaster" element={<LaundryMaster />} /> */}
      <Route path="/salarypaid" element={<SalaryPaid />} />
      {/* <Route path="/grade" element={<Grade/>}/> */}
      <Route path="/reasonforcancel" element={<CancellationReason />} />
      <Route path="/enquiryconversion" element={<EnquiryConversionReport />} />
      <Route path="/complaintsandissues" element={<ComplaintsAndIssues />} />
      <Route path="/revenueexpense" element={<RevenueExpense />} />
      <Route path="/complaintsandissues" element={<ComplaintsAndIssues />} />
      <Route path="/revenueexpense" element={<RevenueExpense />} />
      <Route path="/receipts" element={<Receipt />} />
      <Route path="/housekeeping" element={<HouseKeeping />} />
      <Route path="/laundry" element={<Laundry />} />
      <Route path="/openingstock" element={<OpeningStock />} />
      <Route path="/salarymapping" element={<SalaryMapping />} />
      <Route path="/laundrycompanies" element={<LaundryCompany />} />
      <Route path="/salarypaid" element={<SalaryPaid />} />
      <Route path="/grade" element={<Grade />} />
      <Route path="/reasonforcancel" element={<CancellationReason />} />
      <Route path="/enquiryconversion" element={<EnquiryConversionReport />} />
      <Route path="/complaintsandissues" element={<ComplaintsAndIssues />} />
      <Route path="/revenueexpense" element={<RevenueExpense />} />
      {/* <Route path="/laundry" element={<Laundry />} /> */}
      <Route path="/booked" element={<Booked />} />
      <Route path="/maintenance" element={<Maintenance />} />
      <Route path="/suppliermaster" element={<SupplierMaster />} />
      {/* <Route path="/roomtypemaster" element={<RoomTypeMaster/>}/> */}
      <Route path="/roomtypemaster" element={<RoomType />} />
      <Route path="/rooms" element={<Rooms />} />
      {/* <Route path="/roommaster" element={<RoomMaster />} /> */}
      {/* <Route path="/roomtypemaster" element={<RoomType/>}/> */}
      {/* <Route path="/rooms" element={<Rooms/>}/>  */}
      <Route path="/" element={<Connector />} />
      <Route path="/feedback" element={<Feedback />} />
      <Route path="/villa/:id" element={<Villadetails />} />
      <Route path="/itemscategory" element={<ItemsCategory />} />
      <Route path="/client" element={<Client />} />
      <Route path="/paymentinfomst" element={<PaymentInfoMst />} />
      <Route path="/report1" element={<Report1 />} />
      <Route path="/stockledgerreport" element={<StockLedgerReport />} />
      <Route path="/stockreport" element={<StockReport />} />
      <Route path="/consumption" element={<Consumption />} />
      <Route path="/country" element={<Countrymaster />} />

      <Route path="/damages" element={<Damages />} />
      <Route path="/purchases" element={<PurchaseItem />} />
      <Route path="/space" element={<Space />} />
      <Route path="/cancelled-booking" element={<CancelledBooking />} />

      {/* <Route path="/spacetype" element={<SpaceType />} /> */}

      {/* <Route path="/spacetype" element={<SpaceType />} /> */}

      {/* <Route path="/spacetype" element={<SpaceType />} /> */}

      {/* <Route path="/spacetype" element={<SpaceType/>} /> */}
      <Route path="/checkin" element={<CheckIn />} />
      <Route path="/checkout" element={<CheckOut />} />
      <Route path="/roombooking" element={<RoomBooking />} />
      <Route path="/paymentinfo" element={<PaymentInfo />} />
      <Route path="/amenities" element={<Amenities />} />
      <Route path="/customers" element={<Customers />} />
      <Route path="/space" element={<Space />} />

      <Route path="/mappingroomtypewithamenities" element={<MappingRoomTypeWithAmenities />} />

      <Route path="/mappingroomtypewithspaces" element={<MappingRoomTypeWithSpaces />} />
      <Route path="/state" element={<State />} />
      <Route path="/city" element={<City />} />
     {/* <Route path="/reportenquiryreports" element={<ReportEnquiryReports />} /> */}
      <Route path="/enquirylost" element={<EnquiryLost />} />

      <Route path="/enquiryhold" element={<EnquiryHold />} />

      <Route path="/mapitemstocommonspace" element={<MapItemsToCommonSpace />} />
      <Route path="/issues" element={<Issues />} />
      <Route path="/attendance" element={<Attendance />} />

      <Route path="/foodandbeverages" element={<FoodsAndBeverages />} />
      <Route path="/laundryissue" element={<LaundryIssue />} />
      <Route path="/laundryreceipt" element={<LaundryReceipt />} />
      <Route path="/payroll" element={<Payroll />} />
      <Route path="/logindemo" element={<Logindemo />} />
      <Route path="/logindemo3" element={<Logindemo3 />} />
      <Route path="/enquiryreport" element={<EnquiryReport />} />
      <Route path="/bookingreport" element={<BookingReport />} />
      <Route path="/checkinreport" element={<CheckInReport />} />
      <Route path="/checkoutreport" element={<CheckOutReport />} />
      <Route path="/complaints" element={<Complaints />} />
      <Route path="/sourcetype" element={<Sourcetype />} />

      <Route path="/complaintslist" element={<ComplaintsList />} />
      <Route path="/Position" element={<Position />} />
      
      
    </Routes>
  );
};

export default RootRouter;
